import { filter, OperatorFunction } from "rxjs";

export function nullOrEmpty<T extends "" | [], S extends string | any[]>(value: S | T | null): value is null | T {
  return value == null || value === "" || (Array.isArray(value) && value.length === 0);
}

export function isNotEmpty<T extends string>(value: T | null | undefined): value is Exclude<T, ""> {
  return !!value && !!value.trim().length;
}

export function isNotNull<T>(o: T): o is NonNullable<T> {
  return o != null;
}

export function isTruthy<T>(o: T): o is NonNullable<Exclude<T, "">> {
  return !!o;
}

export function undefinedIfNull(value: string | undefined | null) {
  const trimmedValue = value?.trim();
  return trimmedValue ?? undefined;
}

export function isNotNullFilter<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter(isNotNull);
}
